import DefaultFooter from "@/components/footer/DefaultFooter.component";
import Navbar from "@/components/navbar/Navbar.component";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import style from "./Default.layout.module.scss";
@Component
export default class Default extends Vue {
  render() {
    return (
      <div class="shared-layout">
        <div class={style.container}>
          <Navbar />
          <div class="content">
            <router-view />
          </div>
        </div>
        <DefaultFooter />
      </div>
    );
  }
}
